export default class ContrastDict {
    constructor(contrasts) {
        this.contrasts = contrasts
        this.dict = {};
    }
    toDict() {
        for (let i = 0; i < this.contrasts.length; i++) {
            const c = this.contrasts[i];
            this.dict[c.contrastKey] = {...c};
        }
        return this.dict
    }
}